module.exports = __webpack_public_path__ + "static/media/table-tennis.818d8dd8.svg";